import { render } from "./ReturnMoney.vue?vue&type=template&id=162ab54f&scoped=true"
import script from "./ReturnMoney.vue?vue&type=script&lang=js"
export * from "./ReturnMoney.vue?vue&type=script&lang=js"

import "./ReturnMoney.vue?vue&type=style&index=0&id=162ab54f&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\四个火体育_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-162ab54f"]])

export default __exports__